/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Quotes_Cais_TitleInputs */

const en_home_quotes_cais_title = /** @type {(inputs: Home_Quotes_Cais_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Signed by hundreds of experts, including the top AI labs and scientists`)
};

/**
* | output |
* | --- |
* | "Signed by hundreds of experts, including the top AI labs and scientists" |
*
* @param {Home_Quotes_Cais_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const home_quotes_cais_title = /** @type {((inputs?: Home_Quotes_Cais_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Quotes_Cais_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_home_quotes_cais_title(inputs)
});